import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { LoginRedirectComponent } from './auth/loginrediect/loginredirect.component';
import { GoogleredirectComponent } from './auth/googleredirect/googleredirect.component';

const appRoutes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'trial', component: LoginComponent },
  { path: 'loginredirect', component: LoginRedirectComponent },
  { path: 'googleredirect', component: GoogleredirectComponent },
  {
    path: 'me',
    loadChildren: () => import('./core/core.module').then(m => m.CoreModule),
  },
  {
    path: '**',
    redirectTo: '/login',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { enableTracing: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
